import { ButtonTheme, variants } from './types'
import { lightColors, darkColors } from '../../theme/colors'

const { PRIMARY, SECONDARY, TERTIARY, TEXT, DANGER, SUBTLE, SUCCESS } = variants

export const light: ButtonTheme = {
  [PRIMARY]: {
    background: lightColors.primary,
    backgroundActive: lightColors.primaryDark,
    backgroundHover: lightColors.primaryBright,
    border: 0,
    borderColorHover: 'currentColor',
    boxShadow: 'inset 0px -1px 0px rgba(14, 14, 44, 0.4)',
    boxShadowActive: 'inset 0px -1px 0px rgba(14, 14, 44, 0.4)',
    color: '#FFFFFF',
    colorHover: '#FFFFFF',
  },
  [SECONDARY]: {
    background: lightColors.invertedContrast,
    backgroundActive: lightColors.white,
    backgroundHover: lightColors.primary,
    border: `1px solid ${lightColors.primary}`,
    borderColorHover: lightColors.primary,
    boxShadow: 'none',
    boxShadowActive: 'none',
    color: lightColors.primary,
    colorHover: lightColors.white,
  },
  [TERTIARY]: {
    background: lightColors.tertiary,
    backgroundActive: lightColors.tertiary,
    backgroundHover: lightColors.tertiary,
    border: 0,
    borderColorHover: 'currentColor',
    boxShadow: 'none',
    boxShadowActive: 'none',
    color: lightColors.primary,
    colorHover: lightColors.primary,
  },
  [TEXT]: {
    background: 'transparent',
    backgroundActive: 'transparent',
    backgroundHover: lightColors.tertiary,
    border: 0,
    borderColorHover: 'currentColor',
    boxShadow: 'none',
    boxShadowActive: 'none',
    color: lightColors.primary,
    colorHover: lightColors.primary,
  },
  [DANGER]: {
    background: lightColors.failure,
    backgroundActive: '#D43285', // darkten 10%
    backgroundHover: '#d74956', // lighten 10%
    border: 0,
    borderColorHover: 'currentColor',
    boxShadow: 'none',
    boxShadowActive: 'none',
    color: '#FFFFFF',
    colorHover: '#FFFFFF',
  },
  [SUBTLE]: {
    background: lightColors.textSubtle,
    backgroundActive: `${lightColors.textSubtle}D9`, // 70% opacity
    backgroundHover: `${lightColors.textSubtle}B3`, // 85% opacity
    border: 0,
    borderColorHover: 'currentColor',
    boxShadow: 'none',
    boxShadowActive: 'none',
    color: '#FFFFFF',
    colorHover: '#FFFFFF',
  },
  [SUCCESS]: {
    background: lightColors.success,
    backgroundActive: `${lightColors.success}D9`, // 70% opacity
    backgroundHover: `${lightColors.success}B3`, // 85% opacity
    border: 0,
    borderColorHover: 'currentColor',
    boxShadow: 'none',
    boxShadowActive: 'none',
    color: '#FFFFFF',
    colorHover: '#FFFFFF',
  },
}

export const dark: ButtonTheme = {
  [PRIMARY]: {
    ...light.primary,
  },
  [SECONDARY]: {
    ...light.secondary,
    color: darkColors.text,
    border: `1px solid ${darkColors.border}`,
    background: darkColors.invertedContrast,
  },
  [TERTIARY]: {
    ...light.tertiary,
    background: darkColors.tertiary,
    backgroundActive: darkColors.tertiary,
    backgroundHover: darkColors.tertiary,
    color: darkColors.primary,
  },
  [TEXT]: {
    ...light.text,
    backgroundHover: darkColors.tertiary,
  },
  [DANGER]: {
    ...light.danger,
  },
  [SUBTLE]: {
    ...light.subtle,
  },
  [SUCCESS]: {
    ...light.success,
  },
}
